import React from 'react';
import {FieldViewSmallProps} from "../../../render/view-small";

export default function FieldText_ViewSmall(props:FieldViewSmallProps) {

    const value = props.model[props.field.fieldId]

    const breakId = 'break_{0}'.f(gd.utils.guid());
    const viewValue = _.replace(value, /(?:\r\n|\r|\n)/g, breakId).split(breakId);

    const classes = Classes("ui5-txt-less-important-small ui5-field-view-value-multiline", props.className, {
        "p-t-7 p-b-7 m-t-4 m-b-4": !props.field.noDefaultPaddingMargin
    })

    return (
        <div className={classes}>
            {_.map(viewValue, (value,key)=>(
                <React.Fragment key={key}>
                    {value}
                    <br/>
                </React.Fragment>
            ))}
        </div>
    )
}
